import { render } from "./VocabularyList.vue?vue&type=template&id=917af088&ts=true"
import script from "./VocabularyList.vue?vue&type=script&lang=ts"
export * from "./VocabularyList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__